// Client-side password complexity rules, shared by ChangePassword and the
// self-signup VerifySignup page so both flows show the same inline
// feedback. The server enforces these authoritatively in
// sharedModules.validate_password_complexity; this is display-only, and
// the server message remains the source of truth on submit. Keep this
// list in sync with the server function.

export interface ComplexityRule {
  label: string;
  test: (pw: string) => boolean;
}

export const COMPLEXITY_RULES: readonly ComplexityRule[] = [
  { label: "At least 12 characters", test: (pw: string) => pw.length >= 12 },
  { label: "Uppercase letter", test: (pw: string) => /[A-Z]/.test(pw) },
  { label: "Lowercase letter", test: (pw: string) => /[a-z]/.test(pw) },
  { label: "Number", test: (pw: string) => /\d/.test(pw) },
];

/** The first rule the password fails, or null when all rules pass. */
export function firstUnmetRule(pw: string): string | null {
  for (const rule of COMPLEXITY_RULES) {
    if (!rule.test(pw)) return rule.label;
  }
  return null;
}
